export default __webpack_public_path__ + "static/media/DoubleDutchtreat201460s.7646b16a.mp3";